export default __webpack_public_path__ + "static/media/xml.ce0b057f.png";